import { PureComponent } from 'react'
import PropTypes from 'prop-types'

export default class DurationLoader extends PureComponent {
  static propTypes = {
    children: PropTypes.func.isRequired,

    /**
     * Specifies how long to load.
     */
    duration: PropTypes.number.isRequired,

    /**
     * Specifies how often to update the `value`.
     */
    interval: PropTypes.number.isRequired,

    /**
     * Specifies how of the task has been completed.
     * It must be a valid number between `0` and `1`.
     */
    startValue: PropTypes.number.isRequired
  }

  static defaultProps = {
    duration: 5000,
    interval: 200,
    startValue: 0
  }

  constructor(props) {
    super(props)
    this.state = {
      speed: 1,
      value: props.startValue
    }
  }

  componentDidMount = () => {
    this.startTimer()
  }

  componentWillUnmount = () => {
    this.stopTimer()
  }

  componentDidUpdate = prevProps => {
    if (this.props.duration !== prevProps.duration) {
      this.stopTimer()
      this.startTimer()
    }
  }

  calculateSpeed = value => {
    if (value >= 0.99) {
      return 0
    }

    if (value >= 0.9) {
      return 0.05
    }

    if (value >= 0.8) {
      return 0.1
    }

    return 1
  }

  increment = () => {
    const { duration, interval } = this.props

    this.setState(state => {
      const value = Math.min(
        Math.max(state.value + (interval * state.speed) / duration, 0),
        1
      )

      if (value >= 1) {
        this.stopTimer()
      }

      return {
        speed: this.calculateSpeed(state.value),
        value
      }
    })
  }

  startTimer = () => {
    const { interval } = this.props

    this.timer = setInterval(() => {
      this.increment()
    }, interval)
  }

  stopTimer = () => {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }

  render() {
    return this.props.children({
      value: this.state.value
    })
  }
}
